module.exports = __webpack_public_path__ + "static/media/meow_wait.8dc9a250.png";